import React from 'react';

class BlogAdSense extends React.Component{
    
    componentDidMount(){
        this.loadScript();
    }

    loadScript(){
        try{

            // load once only
            let currScript = document.querySelector('head [data-ad-client=ca-pub-9379236959924950]');
            if(currScript){
                return;
            }
            let script = document.createElement('script');
            script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
            script.setAttribute('data-ad-client', "ca-pub-9379236959924950")
            script.async = true;
            
            document.querySelector('head').appendChild(script);
        }catch(e){}
    }

    render(){
        return null;
    }
}

export default BlogAdSense;